import { useTranslation } from "react-i18next"
import { TextButton } from "../../components/Form/Button/TextButton"
import UsersService from "../../services/users.service"

export const UserStatus = ({row}) => {
    const {t} = useTranslation();
    if(!row.disabled_at){
        return (<TextButton 
            name="updateStatus"
            data={row}
            color={"success"} 
            confirm={t("Are you sure to disable the user?")}
            onConfirm={async () => UsersService.updateStatus(row.id, "disable")}
        >
            {t("Activate")}
        </TextButton>)
    }
    return (
        <TextButton 
            name="updateStatus"
            data={row}
            color={"danger"} 
            confirm={t("Are you sure to activate the user?")}
            onConfirm={async () => UsersService.updateStatus(row.id, "activate")}
        >
            {t("Disable")}
        </TextButton>
    )
}